import {useState, useEffect, useRef, useContext} from 'react';
import clsx from "clsx";
import Icon from "../../../elements/Icon/Icon";
import Button from "../../../elements/Button/Button";
import styles from './Filter.module.scss'
import {AppContext} from "../../../../context/AppContext";

const Filter = ({isDesktop}) => {
    const {filters, changeFilter} = useContext(AppContext);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const ref = useRef();

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsFilterOpen(false);
            }
        };

        isFilterOpen &&
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isFilterOpen]);

    const toggleFilterList = () => {
        setIsFilterOpen(!isFilterOpen);
    };

    return (
        <div className={styles.filter} ref={ref}>
            <Button className={styles.filterButton} onClick={toggleFilterList}>
                Filter {isDesktop && 'by status'}
                <Icon
                    name="arrow-down"
                    size={11}
                    color={'var(--color-teal)'}
                    customStyle={{
                        transition: 'transform 350ms ease-in-out',
                    }}
                />
            </Button>
            {isFilterOpen && (
                <ul className={styles.list}>
                    {['draft', 'pending', 'paid'].map((status) => (
                        <li key={status}>
                            <Button
                                className={clsx(styles.statusFilter, {
                                    [styles.active]: filters.status === status,
                                })}
                                onClick={() => changeFilter('status', filters.status === status ? 'all' : status)}
                            >
                                {status.charAt(0).toUpperCase() + status.slice(1)}
                            </Button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Filter;
